import { movieCardQuery, MovieCard } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createResourceQuery } from '@funtech-int/rival';
import { useResources } from '@funtech-int/rival-react';
import { useAuthManager } from '@funtech-int/yango-shared';

import { queryVariables } from '@/shared/constants/queryVariables';
import { GraphqlClient } from '@/shared/lib/graphqlClient';
import { useGraphqlClient } from '@/shared/hooks/useGraphqlClient';

interface MovieCardVariables {
    contentId: string;
    isAuthorized: boolean;
}

interface GQLQueryParams {
    client: GraphqlClient;
    variables: MovieCardVariables;
}

export type MovieCardResourceQueryResult = MovieCard | undefined | null;
export const movieCardResourceQuery = createResourceQuery<
    GQLQueryParams,
    MovieCardResourceQueryResult
>({
    key(ctx) {
        return [movieCardQuery.name, JSON.stringify(ctx.variables)].join(':');
    },
    fetch(ctx) {
        return ctx.client
            .fetch({
                operation: movieCardQuery,
                variables: {
                    contentId: ctx.variables.contentId,
                    withRating: ctx.variables.isAuthorized ? queryVariables.withRating : false,
                },
            })
            .then(({ data }) => data);
    },
    toJSON(data) {
        return data as any;
    },
    hydrate(data: any) {
        return movieCardQuery.hydrate(data) as any;
    },
});

interface MovieCardQueryParams {
    contentId: string;
}

export function useMovieCard(params: MovieCardQueryParams) {
    const client = useGraphqlClient();
    const { isAuthorized } = useAuthManager();

    const [movie] = useResources(
        movieCardResourceQuery({
            client,
            variables: {
                contentId: params.contentId,
                isAuthorized,
            },
        })
    );

    return { movie };
}
